import styled from 'styled-components';

type Props = {
  $color: string;
  $borderColor: string;
};

export const StyledTag = styled.div<Props>`
  border: ${({ $borderColor }) => `1px solid ${$borderColor}`};
  padding: 2px 8px;
  background-color: ${({ $color }) => $color};
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: fit-content;
`;

export const TextWrapper = styled.div<{ $color: string }>`
  color: ${({ $color }) => $color};
  font-weight: 600;
`;
